import { createStore, combineReducers, applyMiddleware } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';

// Import reducers and action creators:
import {
	async,
	config,
	configuration,
	asyncActionCreators,
	actionChange,
	meme,
	memeActionCreators,
} from './modelReducers';

// Import http client factory
import { httpClientForConfig } from '../../utils/http';

const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
	combineReducers({
		async,
		config,
		meme,
		actionChange,
		router: routerReducer,
	}),
	applyMiddleware(middleware)
);

const httpClient = httpClientForConfig(configuration.dataEndPoints);

export { httpClient, store, history, asyncActionCreators, memeActionCreators };



// WEBPACK FOOTER //
// ./src/js/components/model/store.js